
import request, { setBaseUrl } from '@/service/request'

export const login = (data: USER.Params.Login) => {
  return request<SERVICE.Response<{token: string}>>({
    url: '/web/user/login',
    method: 'POST',
    data
  })
}

export const getCurrUser = () => {
  return request<SERVICE.Response<USER.Detail>>({
    url: '/web/user/currUser',
    method: 'GET'
  })
}

export const getCurrMenu = () => {
  return request<any>({
    url: '/web/user/currMenu',
    method: 'GET'
  })
}
